module.exports = __webpack_public_path__ + "enterprise-software-ux-design.1lx0mZ5x.svg";